import { Component, Inject, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { selects } from '@bl-constants/selects.const';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../modal-findings/modal-findings.component';

@Component({
  selector: 'bid-modal-internal-review',
  templateUrl: './modal-internal-review.component.html',
  styleUrls: ['./modal-internal-review.component.scss'],
})
export class ModalInternalReviewComponent implements OnInit {
  followUp: SelectItem[];
  isPRM = false;
  isPTL = false;
  isFinishIcr = false;
  comentsPTL;
  comentsPRM;
  isSave: boolean;
  onlyLettersNumbers = new RegExp(/^[0-9a-zA-Z]+$/);
  constructor(
    public dialogRef: MatDialogRef<ModalInternalReviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  ngOnInit() {
    this.isSave = false;
    this.followUp = selects.pages.icr_review.multiselects.internalReview;
    var jsonComent = JSON.parse(this.data.term);
    this.comentsPTL = jsonComent.comentsPTL;
    this.comentsPRM = jsonComent.comentsPRM;
    this.isPRM = jsonComent.isPRM;
    this.isPTL = jsonComent.isPTL;
    this.isFinishIcr = jsonComent.isFinishIcr;
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onSaveClick(): void {
    this.isSave = true;
    this.dialogRef.close({
      comentsPTL: this.comentsPTL,
      comentsPRM: this.comentsPRM,
      isSave: this.isSave,
    });
  }
}
